import { selectors } from 'modules/common';
import { backend } from 'modules/data';
import { useMemo } from 'react';

export const usePermissionsSettings = (company: selectors.types.ExpandedCompany, userId: string) => {
    return useMemo(() => {
        const userPermissionsSettings = company.userPermissionsSettings?.[userId];

        const viewPaymentDetails = userPermissionsSettings?.find(
            (setting) => setting.permission === backend.Permission.PaymentDetailsView
        );

        const addPaymentDetails = userPermissionsSettings?.find(
            (setting) => setting.permission === backend.Permission.PaymentDetailsAdd
        );

        const editPaymentDetails = userPermissionsSettings?.find(
            (setting) => setting.permission === backend.Permission.PaymentDetailsEdit
        );

        return {
            viewPaymentDetails,
            addPaymentDetails,
            editPaymentDetails,
        };
    }, [company, userId]);
};
